import script from "./BulkUpdateCampaignLeadStatusDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./BulkUpdateCampaignLeadStatusDialog.vue?vue&type=script&setup=true&lang=js"

import "./BulkUpdateCampaignLeadStatusDialog.vue?vue&type=style&index=0&id=8a706c9a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8a706c9a"]])

export default __exports__